import { Suspense, lazy } from 'react';
// import { Navigate } from 'react-router-dom';
// import AuthGuard from './components/AuthGuard';
// import BlogLayout from './components/blog/BlogLayout';
// import BrowseLayout from './components/BrowseLayout';
import DashboardLayout from './components/dashboard/DashboardLayout';
// import DocsLayout from './components/docs/DocsLayout';
// import GuestGuard from './components/GuestGuard';
import LoadingScreen from './components/LoadingScreen';
// import MainLayout from './components/MainLayout';

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// Other pages

const ThreeJS = Loadable(lazy(() => import('./pages/ThreeJS')));

const routes = [
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      {
        path: '/',
        element: <ThreeJS />
      }
    ]
  }
];

export default routes;
